import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import {
  EmptyGlobalProductsSearch,
  EmptyGlobalSearch,
  getProductsLoading,
  LoadProductsByQuery,
  GlobalSearch,
  getSearchLoading,
} from 'src/app/shop';
import { CloseSearch } from 'src/app/store';

@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SearchBarComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('input') input?: ElementRef<HTMLInputElement>;
  searchForm!: UntypedFormGroup;

  hasValue: boolean = false;

  private _unsubscribe$ = new Subject<void>();

  searchResultsLoading$!: Observable<boolean>;

  constructor(private fb: UntypedFormBuilder, private store: Store, private router: Router) {}

  ngOnInit(): void {
    this.searchResultsLoading$ = this.store.select(getSearchLoading);

    this.searchForm = this.fb.group({
      q: [],
    });

    this.searchForm.valueChanges.pipe(takeUntil(this._unsubscribe$)).subscribe(a => {
      this.onSearch(a?.q);
      this.hasValue = a.q.length;
    });
  }

  ngAfterViewInit(): void {
    if (this.input) {
      this.input.nativeElement.focus();
    }
  }

  onSearch(q?: string) {
    const query = q || this.searchForm?.value?.q;
    if (query && query.length) {
      this.store.dispatch(GlobalSearch({ searchQuery: query }));
    } else {
      this.store.dispatch(EmptyGlobalSearch({ searchQuery: '' }));
    }
  }

  closeSearch() {
    this.store.dispatch(CloseSearch());
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  toOverview() {
    if (this.searchForm?.value?.q) {
      this.router.navigate(['/products', 'search'], { queryParams: { q: this.searchForm?.value?.q } });
    }
  }
}
